export default __webpack_public_path__ + "static/media/team-amico.d736834e.png";